module.exports = __webpack_public_path__ + "img/jw-logo.3fb89855.svg";